// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectwidthauto {
    text-overflow:ellipsis;
    display: inline;
    width: 100%;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    background: none;
    background-color: #73D313;
    width: 11px;
    height: 11px;
    top: 0.55rem;
    left: -1.15rem;
    border-radius: 100%;
}

.btn-warning {
    font-size: calc(14px + (16 - 14) * ((100vw - 320px) / (1920 - 320)));
    font-weight: 600;
    min-height: 40px;
    background-color: #FFA429;
    -webkit-box-align: center;
    transition: all .3s ease-in;
    border-radius: 8px;
    border-color: #FFA429;
    transition: all .3s ease-in;
    color: #fff;
    align-items: center;
    justify-content: center;
    min-width: 100%;
  }
  
.btn-warning:active, .btn-warning:focus, .btn-warning:hover {
    background-color: #E66819 !important;
    border-color: #E66819 !important;
    transition: all .3s ease-in;
    color: #fff !important;
}
  
.btn-warning:disabled{
    cursor: not-allowed;
    pointer-events: all !important;
}

@media (max-width:500px) {
    .upselect { margin-top: 0px !important; }
    .btn-warning{ margin-top: 0px !important;}
}

.foldersize {
    height: 20px;
    width: 20px;
    margin-right: 10px;
}

.iconomobil {
    overflow: inherit;
}

.mat-mdc-raised-button>.mat-icon{
    width: 36px;
    height: 36px;
    padding: 5px;
}

@media (max-width:576px) {
    .container input.form-control{
      margin-bottom: 5px;
    }
    .mat-mdc-dialog-actions .mat-mdc-button-base + .mat-mdc-button-base {
        margin-left: 0 !important;
    }
    .margencorector{
      margin-top: 10px;
    }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
